"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentLinkRequestSchema = exports.DocumentCheckRequestSchema = exports.DOCUMENT_MISSING_INVOICE_DAYS = exports.DOCUMENT_MATCH_DAYS = exports.DOCUMENT_MATCH_AMOUNT_TOLERANCE = exports.DOCUMENT_RUBY_READ_CONTENT_TYPES = exports.DOCUMENT_RUBY_READ_MAX_BYTES = exports.DOCUMENT_AI_FEATURE = exports.DOCUMENT_READ_INVOICE_ACTION_ID = void 0;
exports.normalizeInvoiceNumber = normalizeInvoiceNumber;
/**
 * Document Management — the "intelligent" layer (2026-10-17).
 *
 * Contract for procurement-service `documentsIntel` (one Lambda, separate from the
 * phase-1 `documents` router). Two API methods — `GET|POST /documents/intel/{op}`:
 *   POST ruby-read    {documentId, clientKey}   Ruby reads the invoice (AI · documents.read_invoice)
 *   GET  quote                                  what a Ruby read costs (Ruby Tokens)
 *   GET  insights     ?month=YYYY-MM            insights strip + "deliveries with no invoice" (no AI)
 *   GET  duplicates                             possible-duplicate map for list badges (no AI)
 *   POST check        DocumentCheckRequest      pre-save duplicate + PO/GRN match check (no AI)
 *   GET  suggestions  ?documentId=              likely PO/GRN for an unlinked document (no AI)
 *   POST link         {documentId, poId?, grnId?}  one-tap link to a PO and/or GRN (no AI)
 *   GET  reconcile    ?poId=                    invoices vs received cost on a PO (no AI)
 *
 * Everything except ruby-read is deterministic — it costs no Ruby Tokens.
 */
const zod_1 = require("zod");
/** The Ruby AI action that reads an invoice (registry ACTION#documents.read_invoice). */
exports.DOCUMENT_READ_INVOICE_ACTION_ID = 'documents.read_invoice';
/** Ruby feature gate for document AI actions — needed IN ADDITION to documents.invoices. */
exports.DOCUMENT_AI_FEATURE = 'ai-documents-actions';
/** Ruby reads PDFs and photos only (no Word), up to this size. */
exports.DOCUMENT_RUBY_READ_MAX_BYTES = 15 * 1024 * 1024;
exports.DOCUMENT_RUBY_READ_CONTENT_TYPES = [
    'application/pdf', 'image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif',
];
/** Matching rules (smart match): same vendor, amount within 1 %, date within 30 days. */
exports.DOCUMENT_MATCH_AMOUNT_TOLERANCE = 0.01;
exports.DOCUMENT_MATCH_DAYS = 30;
/** "Ruby found N deliveries with no invoice" looks back this many days. */
exports.DOCUMENT_MISSING_INVOICE_DAYS = 90;
/** Invoice numbers compared case/space/punctuation-insensitively, "INV" prefix and leading zeros dropped: "INV-0042 " ≡ "42". */
function normalizeInvoiceNumber(v) {
    return String(v ?? '').toLowerCase().replace(/[^a-z0-9]/g, '')
        .replace(/^(invoice|inv)(?=\d)/, '')
        .replace(/^0+(?=\d)/, '');
}
exports.DocumentCheckRequestSchema = zod_1.z.object({
    documentId: zod_1.z.string().optional(),
    vendorId: zod_1.z.string().optional(),
    vendorName: zod_1.z.string().optional(),
    invoiceNumber: zod_1.z.string().optional(),
    invoiceDate: zod_1.z.string().optional(),
    amountCents: zod_1.z.number().int().optional(),
});
exports.DocumentLinkRequestSchema = zod_1.z.object({
    poId: zod_1.z.string().optional(),
    grnId: zod_1.z.string().optional(),
    /** Vendor only — set when the document has no vendor yet. */
    vendorId: zod_1.z.string().optional(),
    vendorName: zod_1.z.string().optional(),
});
//# sourceMappingURL=tenantDocumentsIntel.js.map